import { useCallback } from 'react';
import { usePrimaryRowPairView } from '~/hooks/usePrimaryRowPairView';
import { useShowRegistrationComparison } from '~/hooks/viewer/useShowRegistrationComparison';

export function useOpenLandmarkComparison(): () => void {
    const show = useShowRegistrationComparison();
    const { apart } = usePrimaryRowPairView();

    return useCallback(() => {
        if (!apart) {
            show?.();
        }
    }, [apart, show]);
}
